module.exports = __webpack_public_path__ + "files/30bd7764c3a177ea64c69c61e5c45cb0.png";